import React from "react";
import { Button, Modal } from "react-bootstrap";
import moment from 'moment';
import { INPUT_DATE_FORMAT,DATE_FORMAT } from '../../constants/CommonConstants';
import './ChangeDateDialog.css';
import limitDate from '../../Common/LimitDate'


class ChangeDateDialog extends React.Component {
    constructor(props) {
        super(props);
        this.onClickConfirm = this.onClickConfirm.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.resetValuesToInitial= this.resetValuesToInitial.bind(this);
        this.changeBeginDate = this.changeBeginDate.bind(this);
        this.state = {
            fromMaxDate: moment(this.props.toDate).add(-1, 'days').format(INPUT_DATE_FORMAT),
            toMinDate: moment(this.props.fromDate).format(INPUT_DATE_FORMAT),
            toMaxDate: moment().format(DATE_FORMAT),
            fromDate: moment(this.props.fromDate).format(INPUT_DATE_FORMAT),
            toDate: moment(this.props.toDate).format(INPUT_DATE_FORMAT),
            initialFromMaxDate: moment(this.props.toDate).add(-1, 'days').format(INPUT_DATE_FORMAT),
            initialToMinDate: moment(this.props.fromDate).format(INPUT_DATE_FORMAT),
            initialToMaxDate: moment().format(DATE_FORMAT),
            initialFromDate: moment(this.props.fromDate).format(INPUT_DATE_FORMAT),
            initialToDate: moment(this.props.toDate).format(INPUT_DATE_FORMAT),
            beginDateHeader: moment(localStorage.getItem("currentOneBeforeDate")).format(DATE_FORMAT),
            endDateHeader: moment(localStorage.getItem("currentBaseDate")).format(DATE_FORMAT),
        }
    }

    resetValuesToInitial(){
        this.setState({
            fromMaxDate: this.state.initialFromMaxDate,
            toMinDate: this.state.initialToMinDate,
            toMaxDate: this.state.initialToMaxDate,
            fromDate: this.state.initialFromDate,
            toDate: this.state.initialToDate,
        });
    }

    handleClose(){
        this.resetValuesToInitial();    
        this.props.handleClose();
    }

    onClickConfirm(){
        let beginDate = document.getElementById("fromDate").value;
        let endDate = document.getElementById("toDate").value;
        localStorage.setItem('currentOneBeforeDate',moment(beginDate).format(DATE_FORMAT));
        localStorage.setItem('currentBaseDate',moment(endDate).add(1,'day').format(DATE_FORMAT));
        
        this.props.changeDateHeader(beginDate,moment(endDate).add(1,'day').format(INPUT_DATE_FORMAT));
        this.props.handleClose();
    }

    isExportButtonDisabled(){
        if(moment(this.state.fromDate).isValid() && moment(this.state.toDate).isValid() && !moment(this.state.fromDate).isAfter(this.state.toDate)){
            return false;
        }
        return true;
    }

    changeBeginDate(e){
        let beginDate = '';
        let endDate = "";
        if (e.target.value) {
            if (this.props.selectedDuration === 'day') {
                beginDate = moment(e.target.value).format(INPUT_DATE_FORMAT);
                endDate = moment(e.target.value).format(INPUT_DATE_FORMAT);                
            } else if (this.props.selectedDuration === 'week') {
                beginDate = moment(e.target.value).day(0).format(INPUT_DATE_FORMAT);
                endDate = moment(e.target.value).day(6).format(INPUT_DATE_FORMAT);           
            } else if (this.props.selectedDuration === 'month') {
                beginDate = moment(e.target.value).startOf('month').format(INPUT_DATE_FORMAT);
                endDate = moment(e.target.value).endOf('month').format(INPUT_DATE_FORMAT);
            } else {
                beginDate = moment(e.target.value).day(0).format(INPUT_DATE_FORMAT);
                endDate = moment(e.target.value).day(6).format(INPUT_DATE_FORMAT);    
            }
            this.setState({
                fromDate: beginDate,
                toDate: endDate  
            })
        } else {
            this.setState({
                fromDate: this.state.initialFromDate,
                toDate: this.state.initialToDate 
            })
        }    
    }
    
    render(){
        return (
            <Modal id="changeDate" show={this.props.show} onHide={this.handleClose} centered backdrop="static" >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {<div className="content-title">
                            <span>{this.props.intl.formatMessage({ id: "change_date_heading" })}</span>
                        </div>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="label mgT"><span>{this.props.intl.formatMessage({ id: "from" })}</span></div>
                    <div className="inputField fromDate">
                        <input id="fromDate" type="date" name="fromDate" min={limitDate.limitMinDate}  max={limitDate.limitMaxDate} value={this.state.fromDate} onChange={this.changeBeginDate} onKeyDown={(e) => e.preventDefault()} />
                    </div>
                    <div className="label mgT"><span>{this.props.intl.formatMessage({ id: "to" })}</span></div>
                    <div className="inputField toDate">
                        <input id="toDate" type="date" name="toDate" min={limitDate.limitMinDate}  max={limitDate.limitMaxDate} value={this.state.toDate} onChange={this.changeBeginDate} onKeyDown={(e) => e.preventDefault()}/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="secondaryBtn" onClick={this.handleClose}>{this.props.intl.formatMessage({ id: "header_cancel" })}</Button>
                    <Button variant="primary" className="primaryBtn" onClick={this.onClickConfirm} >{this.props.intl.formatMessage({ id: "header_apply" })}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
};

export default ChangeDateDialog;

